import React, { type ReactNode } from 'react';
import {
	InnerWrapper,
	InnerWrapperWithBackground,
	OuterWrapper,
	OuterWrapperWithBackground,
} from './styled';

export const BusinessWrapper = ({
	withWhiteBackground,
	children,
}: {
	withWhiteBackground: boolean;
	children: ReactNode;
}) => {
	if (withWhiteBackground) {
		return (
			<OuterWrapperWithBackground>
				<InnerWrapperWithBackground>{children}</InnerWrapperWithBackground>
			</OuterWrapperWithBackground>
		);
	}

	return (
		<OuterWrapper>
			<InnerWrapper>{children}</InnerWrapper>
		</OuterWrapper>
	);
};
